import type { ApolloError } from '@apollo/client';

export type SignInErrorDialog =
  | 'signUpNotAllowed'
  | 'alreadyLinked'
  | 'noSignUpRole'
  | 'generic';

const SIGN_IN_ERROR_CODES: Record<string, SignInErrorDialog> = {
  DEFAULT_SIGN_UP_NOT_ALLOWED: 'signUpNotAllowed',
  ORG_USER_ALREADY_LINKED: 'alreadyLinked',
  DEFAULT_SIGN_UP_ROLE_MISSING: 'noSignUpRole',
};

export const getSignInErrorCode = (error: ApolloError): string | undefined => {
  const codes = error.graphQLErrors
    .map((graphQLError) => graphQLError.extensions?.code)
    .filter((code): code is string => typeof code === 'string');
  return (
    codes.find((code) => Object.hasOwn(SIGN_IN_ERROR_CODES, code)) ?? codes[0]
  );
};

export const getSignInErrorDialog = (error: ApolloError): SignInErrorDialog => {
  const code = getSignInErrorCode(error);
  return code && Object.hasOwn(SIGN_IN_ERROR_CODES, code)
    ? SIGN_IN_ERROR_CODES[code]
    : 'generic';
};
